import { parseFormattedMessage } from '@rentivo/gatsby-core/src/utils/strings';

export const messagesToFormattedObject = (formatMessage, messages, messagesObject, variables) => {
  let final = {};
  for (let [key] of Object.entries(messagesObject)) {
    final[key] = parseFormattedMessage(formatMessage(messages[key], variables))
  }
  return final;
};
